import { Button, Drawer, Select, Grid } from "antd";
import { SortAscendingOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLeadFilterState } from "../leadSlice";
import "../../crmSharedStyle.css";

const { useBreakpoint } = Grid;

const LeadSortDrawer = ({
  open,
  onClose,
  onApply,
}) => {

  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const { filterState } = useSelector((s) => s.leads);
  const [sortBy, setSortBy] = useState(filterState.sort_by || "created_desc");

  useEffect(() => {
    if (open) {
      setSortBy(filterState.sort_by || "created_desc");
    }
  }, [open, filterState.sort_by]);

  return (
    <Drawer
      title="Sort Leads"
      open={open}
      onClose={onClose}
      width={screens.md ? 320 : "100%"}
      className="crm-drawer"
      styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
    >
      <div className="crm-drawer-body" style={{ padding: 0 }}>
        <div className="crm-form-section">
          <div className="crm-field-label">
            <SortAscendingOutlined />
            Sort by
          </div>
          <Select
            style={{ width: "100%" }}
            value={sortBy}
            onChange={setSortBy}
            options={[
              { label: "Created Date (Newest First)", value: "created_desc" },
              { label: "Created Date (Oldest First)", value: "created_asc" },
              { label: "Last Updated (Newest First)", value: "updated_desc" },
              { label: "Last Updated (Oldest First)", value: "updated_asc" },
            ]}
          />
        </div>

        <Button
          type="primary"
          block
          size="large"
          className="crm-drawer-submit"
          onClick={() => {
            const updated = { ...filterState, sort_by: sortBy };
            dispatch(setLeadFilterState(updated));
            onApply(updated);
          }}
        >
          Apply
        </Button>
      </div>
    </Drawer>
  );
};

export default LeadSortDrawer;